import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui';

export const LoginButton = () => {
  const { login, inProgress } = useAuth();

  const microsoftIcon = (
    <svg viewBox="0 0 23 23" fill="currentColor">
      <rect width="11" height="11" fill="currentColor" />
      <rect x="12" width="11" height="11" fill="currentColor" />
      <rect y="12" width="11" height="11" fill="currentColor" />
      <rect x="12" y="12" width="11" height="11" fill="currentColor" />
    </svg>
  );

  return (
    <Button
      onClick={login}
      disabled={inProgress !== 'none'}
      loading={inProgress !== 'none'}
      variant="primary"
      fullWidth
      size="lg"
      leftIcon={microsoftIcon}
      className="shadow-lg transition-shadow duration-200 hover:shadow-xl"
    >
      Sign in with Microsoft
    </Button>
  );
};
